import type { OrganizationMembershipSummary } from '@cmoh/shared'
import { useQueryClient } from '@tanstack/react-query'
import { useApiRequestMutation } from '@/hooks/use-api'
import { useToast } from '@/hooks/use-toast'
import { useTranslation } from '@/hooks/use-translation'
import { WITHOUT_TAB_ORGANIZATION } from '@/lib/axios'
import { setTabOrganizationId } from '@/lib/tab-organization'

const SWITCH_ORGANIZATION_URL = '/organization/switch'
const ENTRY_PATH = '/'

/** A full-page load on `/` drops every cached resource of the previous organization. */
export function useSwitchMemberOrganization() {
  const queryClient = useQueryClient()
  const { error } = useToast()
  const t = useTranslation()

  const mutation = useApiRequestMutation<OrganizationMembershipSummary, string>(
    (organizationId) => ({
      method: 'post',
      url: SWITCH_ORGANIZATION_URL,
      data: { organizationId },
      config: WITHOUT_TAB_ORGANIZATION,
    }),
    {
      onSuccess: (_response, organizationId) => {
        setTabOrganizationId(organizationId)
        queryClient.clear()
        window.location.href = ENTRY_PATH
      },
      onError: () => {
        error(t('sidebar.orgSwitcher.switchError'))
      },
    },
  )

  return { switchOrganization: mutation.mutate, isSwitching: mutation.isPending }
}
